import React, { useState, useEffect, useRef, useCallback } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Sidebar } from "primereact/sidebar";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import { Dropdown } from "primereact/dropdown";
import { getListaAsignaturas, listaNivel, editarAsignatura, listaProfesores } from "../../../service/CongifCursoHorario";
import { useDispatch, useSelector } from "react-redux";
import { loading } from "../../../actions";
import { useHistory } from "react-router-dom";
import { accionPermiso } from "../../../utilities/Seguridad";
import { Checkbox } from "primereact/checkbox";

export const PageAsignatura = () => {
    const dispatch = useDispatch();

    const [globalFilter, setGlobalFilter] = useState("");
    const toast = useRef(null);

    const [tablaData, setTablaData] = useState([]);
    const [valueNivel, setValueNivel] = useState({});
    const [profesional, setProfesional] = useState([]);
    const [niveles, setNiveles] = useState({});
    const [visibleRight, setVisibleRight] = useState(false);

    const [selectedProfesionales, setSelectedProfesionales] = useState([]);
    const asignatura = useRef({});

    // Permisos
    const history = useHistory();
    const permisos = useRef({ superusuario: false, acciones: [] });
    const { usuario, colegio, anio } = useSelector((state) => ({
        usuario: state.usuario,
        colegio: state.colegio,
        anio: state.anio,
    }));

    try {
        permisos.current.superusuario = usuario.superusuario;
        permisos.current.acciones = usuario.permisos.mantenedor.asignaturas.acciones;
    } catch (error) {
        permisos.current.acciones = [];
    }
    //----------------------------

    const loadListaNivel = async () => {
        if (colegio.id !== undefined) {
            let data = await listaNivel(usuario.token);
            //let coleData = await getListaColegio(usuario.token);
            setNiveles(data.nivel);
            setValueNivel({});
            //setArrayColegio(coleData.colegios);
        }
    };

    useEffect(() => {
        if (accionPermiso(permisos, "ver")) {
            loadListaNivel();
            loadListaProfesor();
        } else {
            history.push("/Acceso");
        }
    }, [anio]);

    useEffect(() => {
        if (valueNivel.id !== undefined) {
            loadListaAsignatura();
        } else {
            setTablaData([]);
        }
    }, [valueNivel]);

    const nameEditor = (props, field) => {
        return props.rowData.tipo == '0' ? inputTextEditor(props, field) : '';
    }

    const inputTextEditor = (props, field) => {
        return <InputText type="text" value={props.rowData[field]} onChange={(e) => onEditorValueChange(props, e.target.value)} onBlur={(e) => onCellEditComplete(props, e.target.value)} />;
    };

    const onEditorValueChange = (props, value) => {
        let udpdateTabla = [...tablaData];
        udpdateTabla[props.rowIndex][props.field] = value;
        setTablaData(udpdateTabla);
    };

    const onCellEditComplete = (props, value) => {
        if (value.trim() !== "") {
            // Guarda[]
            let row = tablaData[props.rowIndex];
            row.array_profe = getProfesionalesArray(row.idsprofesionales);
            saveAsignatura(row);
        }
    }

    const loadListaProfesor = async () => {
        if (colegio.id !== undefined) {
            let rolesData = await listaProfesores(colegio.id, usuario.token);
            //let coleData = await getListaColegio(usuario.token);
            setProfesional(rolesData.profesores);
            //setArrayColegio(coleData.colegios);
        }
    }

    const loadListaAsignatura = async () => {
        if (colegio.id !== undefined) {
            dispatch(loading(true));

            var data = await getListaAsignaturas(colegio.id, valueNivel.id, usuario.token);
            if (data.error == 0) {
                setTablaData(data.asignaturas);
            } else {
                if (data.error == 1) {
                    toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
                } else {
                    console.log("Error");
                }
            }

            dispatch(loading(false));
        }
    };

    const saveAsignatura = async (asignatura) => {
        if (colegio.id !== undefined) {
            dispatch(loading(true));
            let asig = { id: asignatura.idasignatura, alias: asignatura.alias };

            if (asignatura.array_profe.length > 0) {
                let dat = asignatura.array_profe?.map((a) => {
                    return { id: a };
                });

                asig.profesionales_json = JSON.stringify(dat);
            } else {
                asig.profesionales_json = "[]";
            }

            var data = await editarAsignatura(colegio.id, asig, usuario.token);

            if (data.error == 0) {
                loadListaAsignatura();
                // toast.current.show({ severity: "success", summary: "OK", detail: "Registros guardados!", life: 3000 });
            } else {
                if (data.error == 1) {
                    toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
                } else {
                    console.log("Error");
                }
            }
            dispatch(loading(false));
        }
    };

    const onInputChangeNivel = (e) => {
        const val = (e.target && e.target.value) || "";
        setValueNivel(val);
    };

    const getProfesionalesArray = (value) => {
        let ids = value.replaceAll("[", "");
        ids = ids.replaceAll("]", "");
        if (ids.trim() !== "") {
            return ids.split(",").map(Number);
        } else {
            return [];
        }
    };

    const viewProfesional = (data) => {

        if (!accionPermiso(permisos, "asignar")) {
            toast.current.show({ severity: "warn", summary: "Permisos", detail: "No tiene permisos para asignar Profesionales, consulte con el administrador del sistema", life: 3000 });
            return;
        }

        setVisibleRight(true);
        asignatura.current = data;
        asignatura.current.array_profe = getProfesionalesArray(data.idsprofesionales);
        setSelectedProfesionales(asignatura.current.array_profe);
    };



    const dataTableHeader = (
        <div className="table-header">
            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Buscar..." />
            </span>
            <div className="p-col-12 p-md-12 p-lg-4 section p-fluid" style={{ textAlign: "right", padding: "0px" }}>
                <Dropdown value={valueNivel} onChange={(e) => onInputChangeNivel(e)} options={niveles} optionLabel="nivel" placeholder="::Ingrese Nivel::" />
            </div>

            <div className="flex align-items-center export-buttons">
                <Button type="button" icon="pi pi-refresh" className="mr-2" onClick={() => loadListaAsignatura()} tooltip="Actualizar" tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }}></Button>
            </div>
        </div>
    );

    const bodyTemplate = (data, props) => {
        return <> {data[props.field]}</>
    }

    const bodyTemplateAlias = (data, props) => {
        return <>
            {data.tipo == '0' ? (data[props.field] == '' ? <span style={{ opacity: '40%' }}>::Ingrese Alias::</span> : data[props.field]) : ''}
        </>
    }

    const bodyTemplateAsignatura = (data, props) => {
        return <>{data.tipo == '1' ? <div style={{ color: "#007bff" }}>{data[props.field]}</div> : data[props.field]}</>
    }

    const bodyTemplateProfesional = (data, props) => {
        return (
            <> {data.tipo == '0' ? <><span className="p-column-title">{props.header}</span>
                <Button className="p-button-rounded p-mr-1" onClick={() => viewProfesional(data)}>
                    {"+ " + data.total}
                </Button></> : ''}

            </>
        )
    }

    const onCategoryChange = (e) => {
        let _selectedCategories = [...selectedProfesionales];
        let position = _selectedCategories.indexOf(e.value);
        if (e.checked) {
            if (position < 0) _selectedCategories.push(e.value);
        } else {
            if (position >= 0) {
                _selectedCategories.splice(position, 1);
            }
        }
        setSelectedProfesionales(_selectedCategories);
        asignatura.current.array_profe = _selectedCategories;
        saveAsignatura(asignatura.current);
    };

    return (
        <div className="p-grid table-demo">
            <Toast ref={toast} />
            <Sidebar visible={visibleRight} position="right" onHide={() => setVisibleRight(false)}>
                <h5>Profesional</h5>
                {profesional?.map((pro) => {
                    return (
                        <div key={pro.id} className="p-field-checkbox">
                            <Checkbox inputId={pro.id} name="pro" value={pro.id} onChange={onCategoryChange} checked={selectedProfesionales.indexOf(pro.id) >= 0} />
                            <label htmlFor={pro.id}>{pro.profesional}</label>
                        </div>
                    );
                })}
            </Sidebar>
            <DataTable showGridlines
                value={tablaData}
                paginator
                id="13"
                className="p-datatable-customers p-datatable-sm editable-cells-table"
                rowsPerPageOptions={[10, 15, 30]}
                rows={10}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Reg. {first} - {last} de {totalRecords}"
                globalFilter={globalFilter}
                emptyMessage="No existe información!"
                editMode="cell"
                loading={false}
                header={dataTableHeader}
                responsiveLayout="scroll"
                size="small"
            >
                <Column field="nombre" header="Asignatura" body={bodyTemplateAsignatura}></Column>

                {accionPermiso(permisos, "asignar") ? <Column field="alias" header="Alias" style={{ cursor: "pointer" }} body={bodyTemplateAlias} editor={(e) => nameEditor(e, "alias")}></Column> :
                    <Column field="alias" header="Alias"></Column>}

                <Column field="profesionales" header="Profesionales" body={bodyTemplate}></Column>
                <Column headerStyle={{ width: "12rem", textAlign: "center" }} bodyStyle={{ textAlign: "center", overflow: "visible" }} field="total" header="Agregar Profesores" body={bodyTemplateProfesional}></Column>
            </DataTable>

        </div>
    );
};
